import { useCallback, useEffect, useState } from "react";
import { ReportChangeType } from "../../../report/updates/ReportChangeType";
import { useOnUpdate } from "../../../report/updates/ReportUpdates";

export function useHasOutdatedPreview(
  isOpen: boolean,
  isPreviewLoading: boolean,
) {
  const [hasOutdatedPreview, setHasOutdatedPreview] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setHasOutdatedPreview(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isPreviewLoading) {
      setHasOutdatedPreview(false);
    }
  }, [isPreviewLoading]);

  const onRelevantUpdate = useCallback(() => {
    if (isOpen) {
      setHasOutdatedPreview(true);
    }
  }, [isOpen]);

  useOnUpdate(ReportChangeType.Fields, onRelevantUpdate);
  useOnUpdate(ReportChangeType.Signature, onRelevantUpdate);
  useOnUpdate(ReportChangeType.RoleSpecificInfo, onRelevantUpdate);

  return hasOutdatedPreview;
}
